import { Navigate} from 'react-router-dom'
import Layout from '../layouts/layout'

const ProtectRouteDataProvider = ()=>{
     
    const userData = JSON.parse(localStorage.getItem("userData"))

    return userData && (userData.userRole === "DataProvider" ) ? <Layout/> : <Navigate to='/'/>
}
export default ProtectRouteDataProvider